<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-indent:00em; padding-bottom:15px;">Dedicated to Charlotte Ann Burke, loving mother of five, gone from us much too early.</p>
<p style="text-indent:00em;">Her wish for me, ‘To never give up on my dreams,’ so far, so good, Mom.</p>
<p style="text-indent:00em">And also to Barbi, my own personal Angel, truly magical, who has supported those dreams, unfailingly.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7d0c15b2